import { render, staticRenderFns } from "./ReactiveDormant.vue?vue&type=template&id=193157b6&scoped=true"
import script from "./ReactiveDormant.vue?vue&type=script&lang=js"
export * from "./ReactiveDormant.vue?vue&type=script&lang=js"
import style0 from "./ReactiveDormant.vue?vue&type=style&index=0&id=193157b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193157b6",
  null
  
)

export default component.exports